import WithValidityInfo from './WithValidityInfo'

export default WithValidityInfo
